import observable from '@riotjs/observable';
export default observable(new (function() {})());
